import { fromJS } from 'immutable';
const action = name => `/test/${name}`;


export const GET_INSTAFEED_URL = action('GET_INSTAFEED_URL');
export const GET_INSTAFEED_URL_SUCCESS = action('GET_INSTAFEED_URL_SUCCESS');
export const GET_INSTAFEED_URL_ERROR = action('GET_INSTAFEED_URL_ERROR');

export const createInstaFeedURL = data => ({ type: GET_INSTAFEED_URL, data });
export const createInstaFeedURLSuccess = data => ({ type: GET_INSTAFEED_URL_SUCCESS, data });
export const createInstaFeedURLError = data => ({ type: GET_INSTAFEED_URL_ERROR, data });


export const GET_INSTAFEED_USER = action('GET_INSTAFEED_USER');
export const GET_INSTAFEED_USER_SUCCESS = action('GET_INSTAFEED_USER_SUCCESS');
export const GET_INSTAFEED_USER_ERROR = action('GET_INSTAFEED_USER_ERROR');

export const getInstaFeedUser = data => ({ type: GET_INSTAFEED_USER, data });
export const getInstaFeedUserSuccess = data => ({ type: GET_INSTAFEED_USER_SUCCESS, data });
export const getInstaFeedUserError = data => ({ type: GET_INSTAFEED_USER_ERROR, data });

export const INSTAFEED_PAYMANT = action('INSTAFEED_PAYMANT');
export const INSTAFEED_PAYMANT_SUCCESS = action('INSTAFEED_PAYMANT_SUCCESS');
export const INSTAFEED_PAYMANT_ERROR = action('INSTAFEED_PAYMANT_ERROR');

export const instaFeedPaymant = data => ({ type: INSTAFEED_PAYMANT, data });
export const instaFeedPaymantSuccess = data => ({ type: INSTAFEED_PAYMANT_SUCCESS, data });
export const instaFeedPaymantError = data => ({ type: INSTAFEED_PAYMANT_ERROR, data });

const initialState = fromJS({

});

const activity = (state = initialState, action) => {
  switch (action.type) {
    //get user activitiy
    case GET_INSTAFEED_URL_SUCCESS:
      return state.set('instaFeedURL', action.data);

    //get instafeed user
    case GET_INSTAFEED_USER_SUCCESS:
      return state.set('instaFeedUser', action.data);

    //get shopify paymantURL
    case INSTAFEED_PAYMANT_SUCCESS:
      return state.set('paymantUrl', action.data);

    default:
      return state;
  }
};
export default activity;


// WEBPACK FOOTER //
// ./src/ducks/instaFeed.js